var __TEMP__ = require('./_Symbol.js');var Symbol = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./isArguments.js');var isArguments = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./isArray.js');var isArray = __REQUIRE_DEFAULT__(__TEMP__);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = isFlattenable;
